import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-body text-gray-800 selection:bg-brand-gold/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedApproaches data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}